// @ts-nocheck
import * as addPanel from '@/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_box'],
      sections: [addPanel.sections.getSections().box.containerBoxesSection],
    };
  },
};
